// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1ai1x","title":"Images45_title__3RdRu","images":"Images45_images__ubHc1"};